const closeButtons = document.querySelectorAll('.yt-o-message-banner__close');
closeButtons.forEach((closeButton) => {
  closeButton.addEventListener('click', () => {
    closeButton.parentElement?.classList.add('hidden');
  });
});
